// client/src/views/Interactive_parts/GeomanControl.js
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function GeomanControl({ enabled, setIsGeomanActive }) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const ensureGeomanPane = () => {
      if (!map.getPane('geomanPane')) {
        const pane = map.createPane('geomanPane');
        if (pane && pane.style) {
          pane.style.zIndex = 9999;
          pane.style.pointerEvents = 'auto';
        }
      }

      if (map.pm && typeof map.pm.setPathOptions === 'function') {
        map.pm.setPathOptions({
          pane: 'geomanPane',
        });
      }
    };

    const timeoutId = setTimeout(ensureGeomanPane, 0);

    if (enabled) {
      map.pm.addControls({
        position: 'topleft',
        drawMarker: false,
        drawCircle: true,
        drawPolyline: true,
        drawRectangle: true,
        drawPolygon: true,
        drawCircleMarker: false,
        editMode: false,
        dragMode: false,
        cutPolygon: false,
        removalMode: false,
        rotateMode: false,
      });
    } else {
      map.pm.removeControls();
    }

    const handleDrawStart = () => setIsGeomanActive && setIsGeomanActive(true);
    const handleDrawEnd = () => setIsGeomanActive && setIsGeomanActive(false);
    const handleEditStart = () => setIsGeomanActive && setIsGeomanActive(true);
    const handleEditEnd = () => setIsGeomanActive && setIsGeomanActive(false);
    const handleCutStart = () => setIsGeomanActive && setIsGeomanActive(true);
    const handleCutEnd = () => setIsGeomanActive && setIsGeomanActive(false);

    map.on('pm:drawstart', handleDrawStart);
    map.on('pm:drawend', handleDrawEnd);
    map.on('pm:editstart', handleEditStart);
    map.on('pm:editend', handleEditEnd);
    map.on('pm:cutstart', handleCutStart);
    map.on('pm:cutend', handleCutEnd);

    return () => {
      clearTimeout(timeoutId);
      map.off('pm:drawstart', handleDrawStart);
      map.off('pm:drawend', handleDrawEnd);
      map.off('pm:editstart', handleEditStart);
      map.off('pm:editend', handleEditEnd);
      map.off('pm:cutstart', handleCutStart);
      map.off('pm:cutend', handleCutEnd);
      map.pm.removeControls();
    };
  }, [map, enabled, setIsGeomanActive]);

  return null;
}
